const { v1: uuidv1 } = require('uuid');

/**
* @param {import('express').Request} req
* @param {import('express').Response} res
* @param {import('express').NextFunction} next
*/

module.exports = (req, res, next) => {
    if (req.cookies.tdlTrk) {
        res.locals.trackingUuid = req.cookies.tdlTrk;
    } else {
        res.locals.trackingUuid = uuidv1();
        res.cookie('tdlTrk', res.locals.trackingUuid, {
            httpOnly: true,
            secure: process.env.ENV === 'development' ? false : true,
            domain: 'tidal.com',
            maxAge: 30 * 86400000, // 30 days
            sameSite: 'lax',
        });
    }
    next();
};
